export default {"src":"/_next/static/media/schema-lab.f1dedb56.svg","height":156,"width":1266,"blurWidth":0,"blurHeight":0};